// // src/components/LoginPage.js - New login/registration page
// import React, { useState } from 'react';
// import { BookOpen, Eye, EyeOff, Loader2, AlertCircle, CheckCircle } from 'lucide-react';
// import './LoginPage.css';

// const LoginPage = ({ onLogin }) => {
//   const [isLogin, setIsLogin] = useState(true);
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//     first_name: '',
//     last_name: '',
//     company_name: ''
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     setSuccess('');

//     try {
//       if (isLogin) {
//         // Login flow
//         const formDataObj = new FormData();
//         formDataObj.append('username', formData.email);
//         formDataObj.append('password', formData.password);

//         const response = await fetch('/api/auth/login', {
//           method: 'POST',
//           body: formDataObj
//         });

//         if (!response.ok) {
//           const errorData = await response.text();
//           throw new Error('Invalid email or password');
//         }

//         const data = await response.json();
        
//         // Store token and user data
//         localStorage.setItem('access_token', data.access_token);
//         localStorage.removeItem('demo_mode'); // Clear demo mode
        
//         setSuccess('Login successful!');
        
//         // Call parent callback
//         setTimeout(() => {
//           onLogin(data.user, data.access_token);
//         }, 1000);

//       } else {
//         // Registration flow
//         const response = await fetch('/api/auth/register', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             email: formData.email,
//             password: formData.password,
//             first_name: formData.first_name,
//             last_name: formData.last_name,
//             company_name: formData.company_name
//           })
//         });

//         if (!response.ok) {
//           const errorData = await response.text();
//           throw new Error(errorData || 'Registration failed');
//         }

//         const userData = await response.json();
//         setSuccess('Registration successful! Please log in.');
        
//         // Switch to login mode
//         setTimeout(() => {
//           setIsLogin(true);
//           setFormData({ ...formData, first_name: '', last_name: '', company_name: '' });
//         }, 1500);
//       }

//     } catch (error) {
//       console.error('Auth error:', error);
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDemoMode = () => {
//     // Set demo mode and call login with demo user
//     localStorage.setItem('demo_mode', 'true');
//     localStorage.setItem('access_token', 'demo-token');
    
//     const demoUser = {
//       id: 1,
//       email: 'demo@sterling.com',
//       first_name: 'Demo',
//       last_name: 'User',
//       company_name: 'Demo Company'
//     };
    
//     onLogin(demoUser, 'demo-token');
//   };

//   const fillSampleCredentials = () => {
//     setFormData({
//       email: 'john.doe@acmecorp.com',
//       password: 'sterling123',
//       first_name: 'John',
//       last_name: 'Doe', 
//       company_name: 'ACME Corporation'
//     });
//   };

//   return (
//     <div className="login-page">
//       <div className="login-container">
//         {/* Brand Header */}
//         <div className="brand-header">
//           <BookOpen size={40} className="brand-icon" />
//           <h1 className="brand-title">Sterling</h1>
//           <p className="brand-tagline">ask your books anything</p>
//         </div>

//         {/* Auth Form */}
//         <div className="auth-form-container">
//           <div className="auth-tabs">
//             <button 
//               className={`auth-tab ${isLogin ? 'active' : ''}`}
//               onClick={() => setIsLogin(true)}
//             >
//               Sign In
//             </button>
//             <button 
//               className={`auth-tab ${!isLogin ? 'active' : ''}`}
//               onClick={() => setIsLogin(false)}
//             >
//               Sign Up
//             </button>
//           </div>

//           <form onSubmit={handleSubmit} className="auth-form">
//             {!isLogin && (
//               <>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label htmlFor="first_name">First Name</label>
//                     <input
//                       type="text"
//                       id="first_name"
//                       name="first_name"
//                       value={formData.first_name}
//                       onChange={handleInputChange}
//                       required
//                       disabled={loading}
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label htmlFor="last_name">Last Name</label>
//                     <input
//                       type="text"
//                       id="last_name"
//                       name="last_name"
//                       value={formData.last_name}
//                       onChange={handleInputChange}
//                       required
//                       disabled={loading}
//                     />
//                   </div>
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="company_name">Company Name</label>
//                   <input
//                     type="text"
//                     id="company_name"
//                     name="company_name"
//                     value={formData.company_name}
//                     onChange={handleInputChange}
//                     required
//                     disabled={loading}
//                   />
//                 </div>
//               </>
//             )}

//             <div className="form-group">
//               <label htmlFor="email">Email Address</label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleInputChange}
//                 required
//                 disabled={loading}
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="password">Password</label>
//               <div className="password-input">
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   id="password"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   required
//                   disabled={loading}
//                 />
//                 <button
//                   type="button"
//                   className="password-toggle"
//                   onClick={() => setShowPassword(!showPassword)}
//                   disabled={loading}
//                 >
//                   {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
//                 </button>
//               </div>
//             </div>

//             {/* Status Messages */}
//             {error && (
//               <div className="status-message error">
//                 <AlertCircle size={16} />
//                 <span>{error}</span>
//               </div>
//             )}

//             {success && (
//               <div className="status-message success">
//                 <CheckCircle size={16} />
//                 <span>{success}</span>
//               </div>
//             )}

//             {/* Form Actions */}
//             <div className="form-actions">
//               <button 
//                 type="submit" 
//                 className="auth-button primary"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <Loader2 size={16} className="spinning" />
//                     {isLogin ? 'Signing in...' : 'Creating account...'}
//                   </>
//                 ) : (
//                   isLogin ? 'Sign In' : 'Create Account'
//                 )}
//               </button>

//               {isLogin && (
//                 <button 
//                   type="button"
//                   className="auth-button secondary"
//                   onClick={fillSampleCredentials}
//                   disabled={loading}
//                 >
//                   Use Sample Credentials
//                 </button>
//               )}

//               <button 
//                 type="button"
//                 className="auth-button tertiary"
//                 onClick={handleDemoMode}
//                 disabled={loading}
//               >
//                 Try Demo Mode
//               </button>
//             </div>
//           </form>

//           {/* Sample Credentials Info */}
//           <div className="sample-credentials">
//             <h4>Sample Test Account:</h4>
//             <p><strong>Email:</strong> john.doe@acmecorp.com</p>
//             <p><strong>Password:</strong> sterling123</p>
//             <p><em>Click "Use Sample Credentials" to auto-fill</em></p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

// src/components/LoginPage.js - Simplified to prevent hook issues
import React, { useState } from 'react';
import { BookOpen, Eye, EyeOff, Loader2, AlertCircle, CheckCircle } from 'lucide-react';
import './LoginPage.css';
import { API_BASE_URL } from '../utils/api';

const LoginPage = ({ onLogin }) => {
  // All hooks called consistently
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    company_name: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      if (isLogin) {
        // Login flow
        const formDataObj = new FormData();
        formDataObj.append('username', formData.email);
        formDataObj.append('password', formData.password);

        const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
          method: 'POST',
          body: formDataObj
        });

        if (!response.ok) {
          throw new Error('Invalid email or password');
        }

        const data = await response.json();
        
        // Store token and user data
        localStorage.setItem('access_token', data.access_token);
        localStorage.removeItem('demo_mode'); // Clear demo mode
        
        setSuccess('Login successful!');
        
        // Call parent callback
        setTimeout(() => {
          onLogin(data.user, data.access_token);
        }, 1000);

      } else {
        // Registration flow
        const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password,
            first_name: formData.first_name,
            last_name: formData.last_name,
            company_name: formData.company_name
          })
        });

        if (!response.ok) {
          const errorData = await response.text();
          throw new Error(errorData || 'Registration failed');
        }

        setSuccess('Registration successful! Please log in.');
        
        // Switch to login mode
        setTimeout(() => {
          setIsLogin(true);
          setFormData({ ...formData, first_name: '', last_name: '', company_name: '' });
        }, 1500);
      }

    } catch (error) {
      console.error('Auth error:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };



  const fillSampleCredentials = () => {
    setFormData({
      ...formData,
      email: 'john.doe@acmecorp.com',
      password: 'sterling123'
    });
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Brand Header */}
        <div className="brand-header">
          <BookOpen size={40} className="brand-icon" />
          <h1 className="brand-title">Sterling</h1>
          <p className="brand-tagline">ask your books anything</p>
        </div>

        {/* Auth Form */}
        <div className="auth-form-container">
          <div className="auth-tabs">
            <button 
              className={`auth-tab ${isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(true)}
            >
              Sign In
            </button>
            <button 
              className={`auth-tab ${!isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(false)}
            >
              Sign Up
            </button>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            {!isLogin && (
              <>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="first_name">First Name</label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="last_name">Last Name</label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                      required
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="company_name">Company Name</label>
                  <input
                    type="text"
                    id="company_name"
                    name="company_name"
                    value={formData.company_name}
                    onChange={handleInputChange}
                    required
                    disabled={loading}
                  />
                </div>
              </>
            )}

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            {/* Status Messages */}
            {error && (
              <div className="status-message error">
                <AlertCircle size={16} />
                <span>{error}</span>
              </div>
            )}

            {success && (
              <div className="status-message success">
                <CheckCircle size={16} />
                <span>{success}</span>
              </div>
            )}

            {/* Form Actions */}
            <div className="form-actions">
              <button 
                type="submit" 
                className="auth-button primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Loader2 size={16} className="spinning" />
                    {isLogin ? 'Signing in...' : 'Creating account...'}
                  </>
                ) : (
                  isLogin ? 'Sign In' : 'Create Account'
                )}
              </button>

              {isLogin && (
                <button 
                  type="button"
                  className="auth-button secondary"
                  onClick={fillSampleCredentials}
                  disabled={loading}
                >
                  Use Sample Credentials
                </button>
              )}
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default LoginPage;